import { api } from '@/lib/api'

export type ApprovalRequest = {
  id: string
  run_id: string | null
  operation: string
  parameters: Record<string, unknown>
  requested_by: string
  requested_at: string
  status: string
  decided_by: string | null
  decided_at: string | null
  reason: string | null
  expires_at: string
}

export function fetchApprovals(): Promise<ApprovalRequest[]> {
  return api<ApprovalRequest[]>('/approvals')
}

export function decideApproval(
  id: string,
  decision: 'approve' | 'reject',
  reason?: string,
): Promise<{ status: string; id: string; decided_by: string }> {
  return api(`/approvals/${id}/decide`, {
    method: 'POST',
    body: JSON.stringify({ decision, reason: reason ?? null }),
  })
}
